const Divider = ({ className = '', ...rest }) => {
  return <div id="divider" className={`divider ${className}`} {...rest}></div>
}

export default Divider
